<template>
  <div class="chart-panel">
    <div class="chart-panel__header">
      <div :class="titleClasses">
        {{ title }}
      </div>
      <div
        v-if="$slots.panelHeaderActions"
        class="chart-panel__header-actions"
      >
        <slot name="panelHeaderActions" />
      </div>
    </div>
    <div class="chart-panel__content">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  /** The title of the panel */
  title: { type: String, required: false, default: '' },
  /** Will show the title on mobile if true */
  showTitleOnMobile: { type: Boolean, required: false, default: false },
});

const titleClasses = computed(() => {
  return {
    'chart-panel__header-title typo-small-title': true,
    'show-for-medium': !props.showTitleOnMobile,
  };
});
</script>

<style scoped lang="scss">
@import '@/stylesheets/global';

.chart-panel {
  @include breakpoint(medium) {
    background-color: map-get($background-color, lighter);
    border-radius: map-get($border-radius, mega);
    margin-bottom: bu(3);
  }

  &__header {
    @include breakpoint(large) {
      align-items: center;
      border-bottom: 1px solid map-get($background-color, default);
      display: flex;
      height: bu(6);
      padding: 0 bu(4);
    }
  }

  &__header-title {
    border-bottom: 1px solid map-get($background-color, default);
    padding: bu(1);

    @include breakpoint(medium) {
      padding: bu(1.5) bu(4);
    }

    @include breakpoint(large) {
      border-bottom: none;
      margin-right: auto;
      padding: 0;
    }
  }

  &__header-actions {
    align-items: center;
    display: flex;
    justify-content: center;
    padding: bu(0.5);
  }

  &__content {
    padding: bu(1);

    @include breakpoint(medium) {
      flex-direction: row;
      padding: bu(3);
    }
  }
}
</style>
